import React from "react";

/* eslint-disable react/prop-types */

export const WorkspaceContext = React.createContext({
  registerWorkViewCreateItemCallback: () => {},
  unregisterWorkViewCreateItemCallback: () => {},
  registerWorkViewCreateMarkerCallback: () => {},
  unregisterWorkViewCreateMarkerCallback: () => {}
});

export function withWorkspaceContext(Component) {
  const WorkspaceContextComponent = props => {
    const { forwardedRef, ...rest } = props;

    return (
      <WorkspaceContext.Consumer>
        {workViewRegistration => {
          return <Component ref={forwardedRef} {...rest} workViewRegistration={workViewRegistration} />;
        }}
      </WorkspaceContext.Consumer>
    );
  };

  return React.forwardRef((props, ref) => {
    return <WorkspaceContextComponent {...props} forwardedRef={ref} />;
  });
}
